import { FacebookIcon, TwitterIcon, PinterestIcon, LinkedinIcon, FacebookShareButton, TwitterShareButton, PinterestShareButton, LinkedinShareButton } from 'react-share';
import Colors from "../../Color/Colors";
import styles from "./SocialBlock.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var socialLabelsDefault = {
  facebookLabel: '',
  twitterLabel: '',
  pinterestLabel: '',
  linkedinLabel: ''
};
export var SocialBlock = function SocialBlock(_ref) {
  var url = _ref.url,
    title = _ref.title,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? '' : _ref$media,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$facebook = _ref.facebook,
    facebook = _ref$facebook === void 0 ? true : _ref$facebook,
    _ref$twitter = _ref.twitter,
    twitter = _ref$twitter === void 0 ? true : _ref$twitter,
    _ref$pinterest = _ref.pinterest,
    pinterest = _ref$pinterest === void 0 ? true : _ref$pinterest,
    _ref$linkedin = _ref.linkedin,
    linkedin = _ref$linkedin === void 0 ? false : _ref$linkedin,
    _ref$socialLabels = _ref.socialLabels,
    socialLabels = _ref$socialLabels === void 0 ? socialLabelsDefault : _ref$socialLabels;
  var color = Colors.colorWW740;
  var _ref2 = socialLabels ? socialLabels : socialLabelsDefault,
    facebookLabel = _ref2.facebookLabel,
    twitterLabel = _ref2.twitterLabel,
    pinterestLabel = _ref2.pinterestLabel,
    linkedinLabel = _ref2.linkedinLabel;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.socialBlock,
    "data-e2e-name": "social_block",
    children: [url && facebook && /*#__PURE__*/_jsx(FacebookShareButton, {
      url: url,
      quote: title,
      "data-e2e-name": "social_facebook",
      "aria-label": facebookLabel,
      children: /*#__PURE__*/_jsx(FacebookIcon, {
        size: size,
        bgStyle: {
          fill: 'transparent'
        },
        iconFillColor: color,
        className: styles.socialBlockIcon
      })
    }), url && twitter && /*#__PURE__*/_jsx(TwitterShareButton, {
      url: url,
      title: title,
      "data-e2e-name": "social_twitter",
      "aria-label": twitterLabel,
      children: /*#__PURE__*/_jsx(TwitterIcon, {
        size: size,
        bgStyle: {
          fill: 'transparent'
        },
        iconFillColor: color,
        className: styles.socialBlockIcon
      })
    }), url && media && pinterest && /*#__PURE__*/_jsx(PinterestShareButton, {
      url: url,
      media: media,
      description: title,
      "data-e2e-name": "social_pinterest",
      "aria-label": pinterestLabel,
      children: /*#__PURE__*/_jsx(PinterestIcon, {
        size: size,
        bgStyle: {
          fill: 'transparent'
        },
        iconFillColor: color,
        className: styles.socialBlockIcon
      })
    }), url && linkedin && /*#__PURE__*/_jsx(LinkedinShareButton, {
      url: url,
      title: title,
      "data-e2e-name": "social_linkedin",
      "aria-label": linkedinLabel,
      children: /*#__PURE__*/_jsx(LinkedinIcon, {
        size: size,
        bgStyle: {
          fill: 'transparent'
        },
        iconFillColor: color,
        className: styles.socialBlockIcon
      })
    })]
  });
};